import React from 'react';
import PropTypes from 'prop-types';

import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import Button from '@Components/Button';
import StructureOptions from './StructureOptions';

import './StructureOptionsDialog.custom.scss';
import './StructureOptionsDialog.theme.scss';

function StructureOptionsDialog(props) {
  const { ownCurrentOptions, id, onApplyClick } = props;

  if (!ownCurrentOptions) {
    return (
      <GeneralDialogLayout {...props}>
        <RxSpinnerComponent autoStart spinnerScale={1} spinnerId={id} />
      </GeneralDialogLayout>
    );
  }

  return (
    <GeneralDialogLayout {...props}>
      <StructureOptions {...props} />
      <section className="structure-options-dialog-apply">
        <Button
          onClick={onApplyClick}
          buttonConfig={{ type: 'primary', size: 'sm', label: 'Apply', e2eName: 'structure-dialog-apply' }}
          iconConfig={{ name: 'chevron-right', size: 'tiny' }}
        />
      </section>
    </GeneralDialogLayout>
  );
}

StructureOptionsDialog.propTypes = {
  id: PropTypes.string.isRequired,
  ownCurrentOptions: PropTypes.object,
  active: PropTypes.bool,
  onApplyClick: PropTypes.func,
};

export default StructureOptionsDialog;
